import { useQuery } from '@tanstack/react-query';
import { getRoles } from '../utils/rolesCache.utils';
import type { RoleWithPermissionsDto } from '../api/rbac';

export const ROLE_DEFINITIONS_QUERY_KEY = ['role-definitions-rbac'];

/** Shape used by RoleSelection (roleId, roleName, roleDescription). */
export interface RoleDefinition {
  roleId: number;
  roleName: string;
  roleDescription: string | null;
  /** RBAC role code (e.g. Provider, OfficeAdmin). */
  roleCode: string;
}

function mapToRoleDefinition(r: RoleWithPermissionsDto): RoleDefinition {
  return {
    roleId: r.id,
    roleName: r.name ?? r.code,
    roleDescription: r.description ?? null,
    roleCode: r.code,
  };
}

export async function fetchRoleDefinitions(): Promise<RoleDefinition[]> {
  const roles = await getRoles();
  return roles.map(mapToRoleDefinition);
}

export const useRoleDefinitions = () => {
  return useQuery<RoleDefinition[], Error>({
    queryKey: ROLE_DEFINITIONS_QUERY_KEY,
    queryFn: fetchRoleDefinitions,
    staleTime: 5 * 60 * 1000,
  });
};
